import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import cn from 'classnames';

import { IOrganizationListProps } from './OrganizationList.interface';

import './style.scss';

const activeIcon = <CheckBox color="primary" />;
const inactiveIcon = <CheckBoxOutlineBlank color="primary" />;

const OrganizationList: FC<IOrganizationListProps> = ({ data, activeId, onClick }) => {
  const { t } = useTranslation();

  return (
    <div className="organization-list">
      <div className="organization-list__header">
        <div className="organization-list__cell">{t('admin.organization')}</div>
        <div className="organization-list__cell">{t('admin.active')}</div>
      </div>

      {data.map(item => (
        <div
          className={cn('organization-list__row', {
            'organization-list__row_active': item.id === activeId,
          })}
          onClick={() => onClick(item.id)}
          key={item.id}
        >
          <div className="organization-list__cell">{item.name}</div>
          <div className="organization-list__cell">
            <div
              className={cn('organization-list__checkbox', {
                'organization-list__checkbox_active': item.isActive,
                'organization-list__checkbox_inactive': !item.isActive,
              })}
            >
              {item.isActive ? activeIcon : inactiveIcon}
              {item.isActive ? t('admin.active') : t('admin.inactive')}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrganizationList;
